import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PostDetailPage } from "@/features/community/components/post-detail-page";

function PostDetailRoutePage() {
  const params = communityPostRoute.useParams();
  return <PostDetailPage postId={params().postId} />;
}

export const communityPostRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/community/$postId",
  component: PostDetailRoutePage,
});
